module.exports = function getResource(label, vars = []) {
    const resources = {
        addToBasket: 'Ajouter au panier',
        addAllToBasket: 'Tout ajouter au panier',
        addedToBasket: 'Ajouté au panier',
        add: 'Ajouter',
        added: 'Ajouté',
        remove: 'Supprimer',
        exclusive: 'Exclusivement',
        storePickup: 'pour le ramassage en magasin',
        standardShipping: 'pour l’expédition standard',
        sameDayDelivery: 'pour la livraison le jour même',
        sameDayCustomDelivery: `pour ${vars[0]}`,
        autoReplenish: `Livrer chaque ${vars[0]}`,
        alreadyAddedKohls: 'Déjà ajouté au panier'
    };
    return resources[label];
};
